import { AlertCircle } from '@untitled-ui/icons-react'
import * as UntitledIcons from '@untitled-ui/icons-react'
import type { ComponentType, SVGProps } from 'react'

export type UntitledIconComponent = ComponentType<SVGProps<SVGSVGElement>>

export type UntitledIconName = keyof typeof UntitledIcons

export const ALL_BADGE_SYMBOL_ICON_NAMES = Object.keys(UntitledIcons)
  .filter(
    iconName =>
      typeof UntitledIcons[iconName as UntitledIconName] === 'function'
  )
  .sort((left, right) => left.localeCompare(right)) as UntitledIconName[]

export const CURATED_BADGE_SYMBOL_ICON_NAMES = [
  'Activity',
  'AlarmClock',
  'AnnotationHeart',
  'Award01',
  'BarChart01',
  'Bell01',
  'BookOpen01',
  'Bookmark',
  'Briefcase01',
  'Building07',
  'Calendar',
  'Camera01',
  'CheckCircle',
  'Clock',
  'Cloud01',
  'Coins01',
  'Compass',
  'Gift02',
  'CreditCard01',
  'Award02',
  'Diamond01',
  'FaceSmile',
  'FileCheck01',
  'Flag01',
  'Folder',
  'Gift01',
  'Globe01',
  'Heart',
  'Home01',
  'Lightbulb01',
  'Lightning02',
  'Mail02',
  'Map01',
  'Star02',
  'MessageChatCircle',
  'Microphone01',
  'Package',
  'PhoneCall01',
  'PieChart01',
  'Pin02',
  'Rocket02',
  'Shield01',
  'Stars01',
  'Star01',
  'Target05',
  'ThumbsUp',
  'Trophy01',
  'Users01',
  'Wallet03',
  'Zap'
] as const satisfies readonly UntitledIconName[]

export function getUntitledIconComponent(
  iconName: string
): UntitledIconComponent {
  const component = UntitledIcons[iconName as UntitledIconName]

  if (typeof component === 'function') {
    return component as UntitledIconComponent
  }

  return AlertCircle as UntitledIconComponent
}

export function isUntitledIconName(
  iconName: string
): iconName is UntitledIconName {
  return iconName in UntitledIcons
}
